import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQueryParam } from 'use-query-params';

import Menu from 'vibo-ui/Menu';

import { EVENTS_PAGE_MENU_ITEMS } from 'services/constants';
import { getSelectedEventsMenuKeys } from 'services/common/routesHelper';

const EventsNavigation: FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [q] = useQueryParam<string>('q');

  return (
    <Menu
      getSelectedSidebarMenuKeys={getSelectedEventsMenuKeys}
      styleModificator="siderTop"
      mode="horizontal"
    >
      {EVENTS_PAGE_MENU_ITEMS.map(({ name, route }) => (
        <Menu.Item onClick={() => navigate(`${route}${q ? `?q=${q}` : ''}`)} key={route}>
          {t(name)}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default EventsNavigation;
